module.exports = __webpack_public_path__ + "img/bg06.a8d053ab.gif";